/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { ok } from "./utils.js";
export { transformBlobs };
async function transformBlobs(path, data, pipeline) {
    const result = [];
    for (const entry of data) {
        const parts = [];
        for (const part of entry.parts) {
            let newPart = part;
            if ("inlineData" in newPart || "storedData" in newPart) {
                for (const transformer of pipeline) {
                    newPart = await transformer.transform(path, newPart);
                    if (!ok(newPart)) {
                        return newPart;
                    }
                }
            }
            parts.push(newPart);
        }
        result.push({ ...entry, parts });
    }
    return result;
}
//# sourceMappingURL=blob-transform.js.map